import { Col, Row } from 'antd';

interface Props {
  text: React.ReactElement | string;
  subtext?: React.ReactElement | string;
  colSpan?: Array<number>;
}
export const ComponentLogo: React.FC<Props> = ({ text, subtext, colSpan = [3, 21], ...rest }: Props) => {
  return (
    <div style={{ fontSize: 20 }} {...rest}>
      <Row align="middle">
        <Col flex="none" className="self-center mr-2 component-logo-image"></Col>
        <Col span={colSpan[1]}>
          <div style={{ fontSize: 20, position: !subtext ? 'relative' : 'inherit' }}>{text}</div>
          {subtext && <div style={{ marginTop: -4, fontSize: 12, overflowWrap: 'break-word' }}>{subtext}</div>}
        </Col>
      </Row>
    </div>
  );
};
